// extracted by mini-css-extract-plugin
export var blink = "_80-2";
export var cursor = "_80-1";
export var reactMarkdown = "_80-3";
export var streamingText = "_80-0";